import { Col, Label, Panel, Row } from 'react-bootstrap';

interface IProps {
    recipientId: number,
    donorId: number,
    recipientAlias: string,
    donorAlias: string,
    totalEpletMmDr: number,
    totalEpletMmDq: number
}

const CumulativeEpletMismatchLevel = (props: IProps) => {
    let totalEpletMmDrLabel = props.totalEpletMmDr > 11 ? 'danger' : 'success';
    let totalEpletMmDqLabel = props.totalEpletMmDq > 11 ? 'danger' : 'success';

    return (
        <div className='row'>
            <div className='col-xs-12'>
                <Panel bsStyle="primary">
                    <Panel.Heading>
                        HLA-DR/DQ Cumulative Eplet Mismatch Level
                    </Panel.Heading>
                    <Panel.Body>
                        <div>
                            <Row>
                                <Col xs={12}>
                                    <div className="alert alert-info">
                                        This level is based on the older 2017 research: "Class II Eplet Mismatch Modulates Tacrolimus Trough Levels Required to Prevent Donor-Specific Antibody Development".
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} sm={4}>
                                    <div style={{ lineHeight: '25px' }}>
                                        <strong>Total HLA-DR Mismatches:&nbsp;</strong>
                                        <Label id="totalEpletMmDr" bsStyle={totalEpletMmDrLabel}>{props.totalEpletMmDr}</Label>
                                    </div>
                                    <div style={{ lineHeight: '25px' }}>
                                        <strong>Total HLA-DQ Mismatches:&nbsp;</strong>
                                        <Label id="totalEpletMmDq" bsStyle={totalEpletMmDqLabel}>{props.totalEpletMmDq}</Label>
                                    </div>
                                </Col>
                                <Col xs={12} sm={4}>
                                    <ul>
                                        <li>
                                            <strong>Low Risk:</strong> DR {'≤'} 11 and DQ {'≤'} 11
                                        </li>
                                        <li>
                                            <strong>High Risk:</strong> DR {'>'} 11 and DQ {'>'} 11
                                        </li>
                                    </ul>
                                </Col>
                            </Row>
                        </div>
                    </Panel.Body>
                </Panel>
            </div>
        </div>
    );
}

export default CumulativeEpletMismatchLevel;